<template>
    <div class="score-container">
        <b-row class="font-weight-bold mb-1">
            <b-col />
            <b-col> {{ $t('nBox.currentScore') }} </b-col>
            <b-col> {{ $t('nBox.calibratedScore') }} </b-col>
        </b-row>
        <b-row class="mb-1">
            <b-col class="font-weight-bold"> {{ $t('nBox.xAxis') }} </b-col>
            <b-col>
                {{ currentXScore }}
            </b-col>
            <b-col>
                <b-input
                    size="sm"
                    :state="state.x"
                    :value="newXScore"
                    :disabled="disabled"
                    @input="emitUpdatePropEvent('newXScore', $event)"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="font-weight-bold"> {{ $t('nBox.yAxis') }} </b-col>
            <b-col> {{ currentYScore }} </b-col>
            <b-col>
                <b-input
                    size="sm"
                    :state="state.y"
                    :value="newYScore"
                    :disabled="disabled"
                    @input="emitUpdatePropEvent('newYScore', $event)"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        state: Object,
        disabled: Boolean,
        currentScores: Object,
        newXScore: [String, Number],
        newYScore: [String, Number],
    },
    computed: {
        currentXScore() {
            return this.getScoreValue(this.currentScores.x)
        },
        currentYScore() {
            return this.getScoreValue(this.currentScores.y)
        },
    },
    methods: {
        getScoreValue(score) {
            return score !== null ? score : '-'
        },
        emitUpdatePropEvent(prop, value) {
            this.$emit(`update:${prop}`, value)
        },
    },
}
</script>
<style lang="scss" scoped>
.score-container {
    padding: 5px;
    color: #6e6e6e;
    text-align: center;
}
</style>
